import type { ElementType, ReactNode } from 'react';

import { cn } from '../../lib/cn';

export interface EmptyProps {
  /** Tham chiếu tới component biểu tượng, KHÔNG phải một element đã tạo. */
  icon?: ElementType;
  title: string;
  description?: string;
  /** Lời mời hành động. */
  action?: ReactNode;
  className?: string;
}

/**
 * Trạng thái rỗng, hiểu như một lời mời hành động (§9.3.10).
 *
 * **Luôn truyền `action`** khi rỗng thật. Nhưng khi rỗng *vì bộ lọc*, bỏ cả
 * `description` và `action`: mời "tạo cái đầu tiên" trong lúc người dùng chỉ
 * vừa lọc hết kết quả là sai (§10.1).
 */
export function Empty({ icon: Icon, title, description, action, className }: EmptyProps) {
  return (
    <div
      className={cn('flex flex-col items-center justify-center px-6 py-12 text-center', className)}
    >
      {Icon && <Icon aria-hidden className="mb-3 text-4xl text-content-muted" />}
      <p className="text-sm font-medium text-content-primary">{title}</p>
      {description && <p className="mt-1 max-w-sm text-xs text-content-muted">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
